import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

// Auth uses ONLY the httpOnly cookie set by the backend on /auth/login.
// withCredentials makes the browser attach the cookie on every request.
export const api = axios.create({
    baseURL: API,
    withCredentials: true,
});

export function fileUrl(idOrUrl) {
    if (!idOrUrl) return "";
    // Allow storing full URLs directly (e.g. seed data with Unsplash URLs)
    if (/^https?:\/\//.test(idOrUrl)) return idOrUrl;
    return `${API}/files/${idOrUrl}`;
}
